import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/greetings'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(greeting) {
    return http.post(`${resource}`, greeting)
  },
  update(greeting, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, greeting)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
  destroyHeadDepartment(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
